import { render } from 'preact';
import App from './App.tsx';
import './index.css';

const root = document.getElementById('app');

if (!root) throw new Error('Could not find the #app');

render(<App />, root);
